const steps = [
  ["01", "Diagnóstico", "Entendemos el proceso, las personas y los sistemas involucrados."],
  ["02", "Propuesta", "Definimos producto, alcance, integración y ruta de implementación."],
  ["03", "Implementación", "Configuramos, adaptamos y conectamos la solución con tu operación."],
  ["04", "Capacitación", "Preparamos a tu equipo para adoptar el flujo con claridad."],
  ["05", "Soporte y evolución", "Acompañamos la operación y hacemos crecer la solución."],
];

export function ProcessSteps() {
  return `<ol class="process-grid">${steps.map(([number, title, description]) => `
    <li><span>${number}</span><div><h3>${title}</h3><p>${description}</p></div></li>
  `).join("")}</ol>`;
}
